<script>
  export default {
    name: 'ToggleText',
    // props: {
    //   givenStatut: Boolean, // Par défaut, quel est l'affichage du toggle ? Gauche ou droite ?
    //   option1: String,
    //   option2: String,
    //   },
    props:['givenStatut','option1','option2'],
    data(){
      return{
        isTrue: this.givenStatut,
      }
    },
    computed:{
      style1(){
          return{
            'option-selected': !this.isTrue,
          }
      },
      style2(){
          return{
            'option-selected': this.isTrue,
          }
      },
    },

    methods: {
      toggle() {
        this.isTrue = !this.isTrue;
        this.$emit('toggled');
      },
    },
  };
</script>

<template>
    <div class="both" @click="toggle">
      <div class="option" :class="style1">{{option1}}</div>
      <div class="option" :class="style2">{{option2}}</div>
    </div>
</template>

<style scoped lang="scss">
@import '../assets/main.scss';

.both{
  display: flex;
  width: 100%;
}

.option{
  @include myFont;
  border: $black solid 1px;
  padding: 2px 6px 4px 6px;
  min-width: 120px;
  width: 100%;
  text-align: center;
  cursor: pointer;
  color: $black;
  
  
  &:nth-child(1){
    border-radius: 6px 0px 0px 6px;
    border-width: 1px 0px 1px 1px;
  }

  &:nth-child(2){
    border-radius: 0px 6px 6px 0px;
    border-width: 1px 1px 1px 0px;
  }

  &-selected{
    // font-weight: 600;
    color: $main;
    border-color: $main;
    background-color: $main-lighter;
    border-width: 1px 1px 1px 1px !important;
  }  

  &:hover{
    @include myHover;
  }
}


</style>